import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Button, Stack, Text} from '@chakra-ui/react'
import {ChevronRightIcon} from '@chakra-ui/icons'
import {AnimatePresence, motion} from 'framer-motion'
import Link from '@salesforce/retail-react-app/app/components/link'
import {animationVariants} from './animation-variants'
import {categoryUrlBuilder} from '../../../utils/url'


const MotionStack = motion(Stack)

const NestedCategoryMenu = ({
    currentCategory,
    navDirection,
    onClose,
    CategoryTree,
    isRootCategory,
    categoriesList = []
}) => {
    const [activeSubcategory, setActiveSubcategory] = useState(null)

    const handleSubcategoryClick = (subcategory) => {
        setActiveSubcategory(subcategory.id)
    }

    const renderSubcategory = (subcategory) => {
        const {id, name, onlineSubCategoriesCount = 0} = subcategory
        const hasChildren = onlineSubCategoriesCount > 0
        const isActive = activeSubcategory === id

        if (isActive && hasChildren) {
            return (
                <CategoryTree
                    key={id}
                    item={subcategory}
                    currentCategory={subcategory}
                    itemComponent={NestedCategoryMenu}
                    navDirection={navDirection}
                    onClose={onClose}
                    withReactQuery={true}
                />
            )
        }

        if (hasChildren) {
            return (
                <Button
                    key={id}
                    variant="filterLink"
                    justifyContent="space-between"
                    onClick={() => handleSubcategoryClick(subcategory)}
                    rightIcon={<ChevronRightIcon />}
                >
                    <Text flex="1" textAlign="left">
                        {name}
                    </Text>
                </Button>
            )
        }

        return (
            <Link to={categoryUrlBuilder(subcategory)} key={id}>
                <Button
                    variant="filterLink"
                    justifyContent="flex-start"
                    w="100%"
                    onClick={() => onClose?.()}
                >
                    <Text flex="1" textAlign="left">
                        {name}
                    </Text>
                </Button>
            </Link>
        )
    }

    const subcategories = currentCategory?.categories || categoriesList

    return (
        <AnimatePresence mode="wait" initial={false} custom={navDirection}>
            <MotionStack
                key={currentCategory?.id}
                spacing={0}
                custom={navDirection}
                variants={animationVariants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{duration: 0.1, ease: 'easeInOut'}}
            >
                {!isRootCategory && currentCategory?.onlineSubCategoriesCount > 0 && (
                    <Link
                        to={categoryUrlBuilder(currentCategory)}
                        key={`all-${currentCategory.id}`}
                        _hover={{textDecoration: 'none'}}
                    >
                        <Button
                            variant="filterLink"
                            justifyContent="flex-start"
                            w="100%"
                            onClick={() => onClose?.()}
                        >
                            All {currentCategory.name}
                        </Button>
                    </Link>
                )}

                {subcategories.map(renderSubcategory)}
            </MotionStack>
        </AnimatePresence>
    )
}

NestedCategoryMenu.propTypes = {
    currentCategory: PropTypes.object,
    navDirection: PropTypes.string,
    onClose: PropTypes.func,
    CategoryTree: PropTypes.func,
    isRootCategory: PropTypes.bool,
    categoriesList: PropTypes.array
}

export default NestedCategoryMenu
